import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'

export interface CredentialSetSummary {
  id: string
  name: string
}

/**
 * Fetches every credential set (admin-only `credential_sets:read`). Used by
 * the adapter Test panel so an admin can pick which set to thread onto the
 * AdapterContext when dry-running a credential-requiring capability.
 *
 * Pass `enabled: false` to short-circuit (e.g. modal closed / non-admin).
 */
export function useAllCredentialSets(enabled = true) {
  return useQuery({
    queryKey: ['credential-sets', 'all'],
    queryFn: async (): Promise<CredentialSetSummary[]> => {
      const res = await apiClient.fetch('/api/admin/credential-sets')
      if (!res.ok) throw new Error('Failed to load credential sets')
      return res.json()
    },
    enabled,
  })
}
